import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './LegalPage.css';

const DataDeletionPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const confirmationCode = searchParams.get('code');

  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>Facebook Data Deletion</h1>
        <p className="legal-meta">How to delete your KeeDocs data linked to Facebook</p>
      </div>

      {confirmationCode && (
        <div className="legal-section" style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '16px 24px', marginBottom: 24 }}>
          <p style={{ margin: 0, color: '#15803d', fontWeight: 600 }}>
            ✓ Your data deletion request has been received.
          </p>
          <p style={{ margin: '8px 0 0', color: '#166534', fontSize: '0.875rem' }}>
            Confirmation code: <code style={{ background: '#dcfce7', padding: '2px 6px', borderRadius: 4 }}>{confirmationCode}</code>
          </p>
          <p style={{ margin: '8px 0 0', color: '#166534', fontSize: '0.875rem' }}>
            Your account and all associated data will be permanently deleted within 30 days.
          </p>
        </div>
      )}

      <div className="legal-section">
        <h2>What data KeeDocs stores</h2>
        <p>When you sign in with Facebook, KeeDocs stores:</p>
        <ul>
          <li>Your name and email address (provided by Facebook at sign-in)</li>
          <li>Documents you have uploaded</li>
          <li>Document sharing settings and access logs</li>
        </ul>
      </div>

      <div className="legal-section">
        <h2>How to delete your data</h2>
        <p>You have two options:</p>

        <p><strong>Option 1 — Delete your account from KeeDocs</strong></p>
        <ol>
          <li>Sign in to <Link to="/login">KeeDocs</Link> using your Facebook account</li>
          <li>Go to your <Link to="/profile">Profile</Link> page</li>
          <li>Click <strong>Delete Account</strong></li>
          <li>Confirm the deletion</li>
        </ol>
        <p>
          This permanently deletes your account, all uploaded documents, sharing permissions,
          and activity logs from our systems within 30 days.
        </p>

        <p><strong>Option 2 — Contact us</strong></p>
        <p>
          If you are unable to sign in, use our <Link to="/contact">Contact page</Link> to
          submit a deletion request. Include the email address associated with your Facebook
          account and we will process the request manually within 30 days.
        </p>
      </div>

      <div className="legal-section">
        <h2>What happens after deletion</h2>
        <ul>
          <li>Your account and profile are permanently removed</li>
          <li>All documents you uploaded are deleted from our servers</li>
          <li>Sharing links to your documents stop working</li>
          <li>Activity logs referencing your account are purged within 30 days</li>
          <li>This action cannot be undone</li>
        </ul>
      </div>

      <div className="legal-section">
        <div className="legal-contact">
          <p>
            For any questions about data deletion, contact us via our{' '}
            <Link to="/contact">Contact page</Link> or review our{' '}
            <Link to="/privacy">Privacy Policy</Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DataDeletionPage;
